import { useEffect, useRef, useState } from "react"
import { CommunityAdminPopupModel } from "../models/CommunityAdminPopupModel";

type Props = {
    items: CommunityAdminPopupModel[];
}

export const CommunityAdminPopUp = ({ items }: Props) => {
    const wrapperRef = useRef<HTMLDivElement>(null);
    const menuRef = useRef<HTMLDivElement>(null);
    const [show, setShow] = useState(false);


    useEffect(() => {
        const _handleClickOutside = (e: MouseEvent) => {
            if(!wrapperRef.current)
                return;
            if (!wrapperRef.current.contains(e.target as Node)) {
                setShow(false);
            }
        }


        document.addEventListener('mousedown', _handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', _handleClickOutside);
        }
    }, []);

    return (
        <>
            <div
                onClick={() => setShow(prev => !prev)} 
                style={{ position: 'relative', cursor: 'pointer', maxWidth: '12px', height: '12px', background: 'none', border: '0', padding: 0}}
                ref={wrapperRef}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <circle cx="1" cy="6" r="1" fill="#151515"/>
                    <circle cx="6" cy="6" r="1" fill="#151515"/>
                    <circle cx="11" cy="6" r="1" fill="#151515"/>
                </svg>
                {show && (
                    <div className="admin-popup-community" ref={menuRef}>
                        {items.map((l, i) => (
                            <button key={i} onClick={l.cb}>
                                {l.label}
                            </button>
                        ))}
                    </div>
                )}    
            </div>
        </>
    )
}